/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IInspectorControl_Enum, TInspectorControlProps } from "../InspectorControlTypes";

export interface IInspectorControlEnumProps extends TInspectorControlProps<IInspectorControl_Enum> {}

export const schemaName = "constEnum";
